const introductionTitle = document.querySelector(".introduction__title");
const introductionDesc = document.querySelector(".introduction__desc");

const addMargin = (element) => {
	let position = introductionTitle.getBoundingClientRect().top.toFixed(0) - introductionDesc.getBoundingClientRect().top.toFixed(0);
	element.style.marginTop = `${position}px`;
};

export { introductionDesc, addMargin };
